import { SddStatus } from '../../communication/customer/CustomerDueDiligenceApi'

export enum SddStatusEventType {
	SDD_STATUS_FETCH_STARTED = 'SDD_STATUS_FETCH_STARTED',
	SDD_STATUS_RECEIVED = 'SDD_STATUS_RECEIVED',
	SDD_STATUS_FETCH_FAILED = 'SDD_STATUS_FETCH_FAILED',
}

export interface SddStatusFetchStarted {
	type: typeof SddStatusEventType.SDD_STATUS_FETCH_STARTED;
}

export interface SddStatusReceived {
	type: typeof SddStatusEventType.SDD_STATUS_RECEIVED;
	payload: SddStatus;
}

export interface SddStatusFetchFailed {
	type: typeof SddStatusEventType.SDD_STATUS_FETCH_FAILED;
	payload: string;
}

export type SddStatusEvent =
	| SddStatusFetchStarted
	| SddStatusReceived
	| SddStatusFetchFailed

export const createSddStatusFetchStarted = (): SddStatusFetchStarted => ({
	type: SddStatusEventType.SDD_STATUS_FETCH_STARTED,
})

export const createSddStatusReceived = (status: SddStatus): SddStatusReceived => ({
	type: SddStatusEventType.SDD_STATUS_RECEIVED,
	payload: status,
})

export const createSddStatusFetchFailed = (error: string): SddStatusFetchFailed => ({
	type: SddStatusEventType.SDD_STATUS_FETCH_FAILED,
	payload: error,
})
